import { IPreloadedState } from 'shared/types/redux';

export const selectHouseAddress = (state: IPreloadedState) => state.houseInfo.geo.address;
